module.exports = __webpack_public_path__ + "static/media/25.1b94972f.jpg";